/**
 * Simple Page Tracker Component
 * Automatically tracks page views on page loads
 */

import { useEffect } from "react";
import { useSegmentTracking } from "./tracking";
import { addDatadogError } from "src/utils/datadog";

/**
 * Component that automatically tracks page views on page loads
 * Should be used in page components or layout components
 */
export const PageTracker = ({ children }: { children: React.ReactNode }) => {
  const { trackPageView } = useSegmentTracking();

  useEffect(() => {
    // Track Page View on page load
    // trackPageView is already wrapped in try-catch internally
    try {
      trackPageView();
    } catch (error) {
      // Additional safety net - should not reach here due to internal try-catch
      addDatadogError("PageTrackerTrackingError", String(error));
    }
  }, [trackPageView]);

  return <>{children}</>;
};
